import React, { type ComponentType } from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { ButtonItem } from '@atlaskit/menu';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import messages from './messages.tsx';

export type Props = {
	isDisabled: boolean;
	onClick: () => void;
};

export const ColumnLimitsMenuItem = (props: Props) => {
	const { formatMessage } = useIntl();
	return fg('horizn_490_consolidate_old_issues_in_board') ? (
		<ButtonItem
			data-testid="software-board.board-container.board.column.header.menu.item-limits"
			isDisabled={props.isDisabled}
			onClick={props.onClick}
			role="menuitem"
		>
			{formatMessage(messages.displayText)}
		</ButtonItem>
	) : (
		<DropdownItem
			data-testid="software-board.board-container.board.column.header.menu.item-limits"
			isDisabled={props.isDisabled}
			onClick={props.onClick}
		>
			{formatMessage(messages.displayText)}
		</DropdownItem>
	);
};

export const hideableMenuItem =
	(MenuItem: ComponentType<Props>): ComponentType<Props> =>
	(props: Props) =>
		!props.isDisabled ? <MenuItem {...props} /> : null;

export default hideableMenuItem(ColumnLimitsMenuItem);
